import { createReducer, on } from "@ngrx/store"
import { RegulationFilterModel } from "src/app/core/models/regulation"
import * as groupingActions from "./grouping.actions"

export interface State {
  grouping: groupingState
}
export interface groupingState {
  groups: GroupState[],
  groupByEnabled: boolean,
  groupBy: "PubType" | "Country" | "MappingId",
  pageIndex: number,
  filterType: 'Open' | 'Actioned' | 'Future Updates' | 'Other',
  filter: string[],
  navHeight: number
}
export interface GroupState {
  groupByColumnData: string,
  otherDataSummary: string,
  totalCount: number,
  pannelData: any[],
  panelOpenState: boolean,
  pageSize: number,
  pageIndex: number,
  isPanelIdSelected: boolean;
  lastSelected: number | 0;
  totalSelectedRow: number | 0;
  isLoading: boolean;
  activeItemCount: number | 0;
  clickFilter?: string;
  isActionDone:boolean;
}

const persistFilter = JSON.parse(localStorage.getItem("regulationFilter") as string) as RegulationFilterModel;

export const initialState: groupingState = {
  groups: [],
  groupByEnabled: false,
  groupBy: (persistFilter && persistFilter.GroupBy) ? persistFilter.GroupBy : "MappingId",
  pageIndex: 0,
  filterType: "Open",
  filter: [],
  navHeight: 0
}


const _groupingReducer = createReducer(
  initialState,

  on(groupingActions.setGroupData, (state, action) => {
    return {
      ...state,
      groups: action.data
    }
  }),

  on(groupingActions.setPannelData, (state, action) => {
    return {
      ...state,
      groups: state.groups.map(group => ({ ...group }))
        .map(group => {
          if (group.groupByColumnData === action.pannelName) {
            return {
              ...group,
              pannelData: action.data
            }

          }
          else
            return group
        })
    }

  }),
  on(groupingActions.addPannelData, (state, action) => {
    return {
      ...state,
      groups: state.groups.map(group => ({ ...group }))
        .map(group => {
          if (group.groupByColumnData === action.pannelName) {
            return {
              ...group,
              pannelData: [...group.pannelData, ...action.data]
            }

          }
          else
            return group
        })
    }

  }),


  on(groupingActions.updateGroupByEnabled, (state, action) => {
    return {
      ...state,
      groupByEnabled: action.data
    }
  }),

  on(groupingActions.updateGroupBy, (state, action) => {
    return {
      ...state,
      groupBy: action.data
    }
  }),

  on(groupingActions.updateGroupPagination, (state, action) => {
    return {
      ...state,
      pageIndex: action.data
    }
  }),

  on(groupingActions.updateFilter, (state, action) => {
    return {
      ...state,
      filter: action.data
    }
  }),

  on(groupingActions.updateFilterType, 
    (state:any, action) => {
    return {
      ...state,
      filterType: action.data
    }
  }
  ),

  on(groupingActions.updateNavHeight, (state, action) => {
    return {
      ...state,
      navHeight: action.data
    }
  }),

  on(groupingActions.updatePannelOpenState, (state, action) => {
    return {
      ...state,
      groups: state.groups.map(group => ({ ...group }))
        .map(group => {
          if (group.groupByColumnData === action.groupByColumnData) {
            return {
              ...group,
              panelOpenState: action.data
            }
          }
          else
            return group
        })
    }
  }),
  on(groupingActions.updatePannelPagination, (state, action) => {
    return {
      ...state,
      groups: state.groups.map(group => ({ ...group }))
        .map(group => {
          if (group.groupByColumnData === action.groupByColumnData) {
            return {
              ...group,
              pageSize: action.data.pageSize,
              pageIndex: action.data.pageIndex
            }
          }
          else
            return group
        })
    }
  })
)


export function groupingReducer(state:any, action:any) {
  return _groupingReducer(state, action);
}
